import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaCheckCircle, FaClock, FaRupeeSign, FaUserGraduate, FaFlask, FaHeart, FaHandsHelping } from "react-icons/fa";
import { GiNurseFemale } from "react-icons/gi";

const BScNursingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <nav className="flex text-sm text-gray-500">
            <Link to="/" className="hover:text-blue-600">Home</Link>
            <span className="mx-2">/</span>
            <Link to="/courses" className="hover:text-blue-600">Courses</Link>
            <span className="mx-2">/</span>
            <span className="text-blue-600 font-semibold">B.Sc. Nursing</span>
          </nav>
        </div>
        <div className="bg-gradient-to-r from-blue-600 to-green-600 rounded-3xl p-8 mb-8 text-white relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-32 translate-x-32"></div>
          <div className="relative flex items-center gap-4">
            <div className="bg-white/30 p-4 rounded-2xl backdrop-blur-sm">
              <GiNurseFemale className="text-5xl" />
            </div>
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-2">B.Sc. Nursing</h1>
              <p className="text-xl text-white/90">Bachelor of Science in Nursing</p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 space-y-8">
            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">About the Course</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                B.Sc. Nursing is a four-year undergraduate program that prepares students to become professional nurses with advanced clinical skills and knowledge. The curriculum covers all aspects of nursing, including medical-surgical nursing, pediatric nursing, psychiatric nursing, community health nursing, and nursing research.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Students receive comprehensive training in patient care, medication administration, critical care, and nursing administration, preparing them for leadership roles in healthcare settings.
              </p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Program Highlights</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-start gap-3">
                  <FaCheckCircle className="text-blue-600 text-xl mt-1" />
                  <div>
                    <p className="font-semibold text-gray-800">Clinical Training</p>
                    <p className="text-sm text-gray-600">Hands-on training in affiliated hospitals</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <FaCheckCircle className="text-green-600 text-xl mt-1" />
                  <div>
                    <p className="font-semibold text-gray-800">Govt. Approved</p>
                    <p className="text-sm text-gray-600">Approved by Indian Nursing Council</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <FaCheckCircle className="text-blue-600 text-xl mt-1" />
                  <div>
                    <p className="font-semibold text-gray-800">Placement Aid</p>
                    <p className="text-sm text-gray-600">100% placement assistance</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <FaCheckCircle className="text-green-600 text-xl mt-1" />
                  <div>
                    <p className="font-semibold text-gray-800">Research Focus</p>
                    <p className="text-sm text-gray-600">Emphasis on evidence-based practice</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Career Opportunities</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div className="bg-gradient-to-r from-blue-50 to-green-50 p-4 rounded-xl text-center">
                  <p className="font-semibold text-gray-800">Teaching Hospitals</p>
                </div>
                <div className="bg-gradient-to-r from-blue-50 to-green-50 p-4 rounded-xl text-center">
                  <p className="font-semibold text-gray-800">Research Institutes</p>
                </div>
                <div className="bg-gradient-to-r from-blue-50 to-green-50 p-4 rounded-xl text-center">
                  <p className="font-semibold text-gray-800">Overseas Opportunities</p>
                </div>
                <div className="bg-gradient-to-r from-blue-50 to-green-50 p-4 rounded-xl text-center">
                  <p className="font-semibold text-gray-800">Nursing Administration</p>
                </div>
                <div className="bg-gradient-to-r from-blue-50 to-green-50 p-4 rounded-xl text-center">
                  <p className="font-semibold text-gray-800">Critical Care Units</p>
                </div>
                <div className="bg-gradient-to-r from-blue-50 to-green-50 p-4 rounded-xl text-center">
                  <p className="font-semibold text-gray-800">Nursing Education</p>
                </div>
              </div>
            </div>
          </div>
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-2xl shadow-lg sticky top-24">
              <h3 className="text-xl font-bold text-gray-800 mb-4">Course Information</h3>
              
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                    <FaClock className="text-blue-600" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Duration</p>
                    <p className="font-semibold text-gray-800">4 Years</p>
                  </div>
                </div>
                
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <FaUserGraduate className="text-green-600" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Eligibility</p>
                    <p className="font-semibold text-gray-800">10+2 PCB (50%)</p>
                  </div>
                </div>
                
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                    <FaRupeeSign className="text-blue-600" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Course Fees</p>
                    <p className="font-semibold text-gray-800">₹110000 per year</p>
                  </div>
                </div>
              </div>

              <div className="border-t border-gray-200 my-6"></div>

              <h3 className="text-xl font-bold text-gray-800 mb-4">Admission Details</h3>
              <div className="space-y-3">
                <p className="text-sm text-gray-600">📅 Admission Start: <span className="font-semibold"> 1 April 2026</span></p>
                <p className="text-sm text-gray-600">🎯 Total Seats: <span className="font-semibold">40 </span></p>
                <p className="text-sm text-gray-600">📝 Mode: <span className="font-semibold">Merit Based / Entrance</span></p>
              </div>

              <div className="mt-6 space-y-3">
                <Link
                  to="/admission"
                  className="block w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-green-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-green-700 transition-all duration-300 text-center"
                >
                  Apply Now <FaArrowRight className="inline ml-2" />
                </Link>
                <button className="w-full py-3 px-4 border-2 border-blue-600 text-blue-600 font-semibold rounded-xl hover:bg-blue-50 transition-all duration-300">
                  Download Brochure
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BScNursingPage;